module.exports = {"130827100":"宽城镇","130827101":"龙须门镇","130827102":"峪耳崖镇","130827103":"板城镇","130827104":"汤道河镇","130827105":"饽罗台镇","130827106":"碾子峪镇","130827107":"亮甲台镇","130827108":"化皮溜子镇","130827109":"松岭镇","130827201":"塌山乡","130827203":"孟子岭乡","130827204":"独石沟乡","130827207":"铧尖乡","130827208":"东黄花川乡","130827210":"苇子沟乡","130827211":"大字沟门乡","130827212":"大石柱子乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130827.json
// module id = 209
// module chunks = 0